<template>
  <footer class="footer bg-black small text-center text-white-50">
    <span v-html="t('footer.credit')"></span>
    <div class="container">{{ t('footer.copyright') }}</div>
  </footer>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
</script>
